import React from 'react'
import { Button } from 'react-bootstrap-v5'

type Props = {
  setTodayPayment: React.Dispatch<React.SetStateAction<boolean>>,
  setDelayedPayment: React.Dispatch<React.SetStateAction<boolean>>,
  setTodayRecall: React.Dispatch<React.SetStateAction<boolean>>,
  setPassedExpiry: React.Dispatch<React.SetStateAction<boolean>>
}

const CustomerFilter:React.FC<Props> = ({setTodayPayment, setDelayedPayment, setTodayRecall, setPassedExpiry}) => {
  return (
    <div>
      <div className='form-group'>
        <div className='checkbox-inline d-flex justify-content-between bg-gray-300'>
          <div className='form-check form-check-custom form-check-solid rounded-start rounded-end custom-control custom-checkbox'>
            <input className='form-check-input fw-bolder custom-control-input my-error' type='checkbox' id='today-payment' onChange={(e) => setTodayPayment(e.target.checked)} style={{border: "3px solid #ffed00"}}/>
            <label className='form-check-label custom-control-label' htmlFor='today-payment'>
              Bugün Ödeme Yapacakları Göster
            </label>
          </div>
          <div className='form-check form-check-custom form-check-solid me-5 p-2 rounded-start rounded-end'>
            <input className='form-check-input' type='checkbox' id='past-payment' onChange={(e) => setDelayedPayment(e.target.checked)} style={{border: "3px solid #ffed00"}}/>
            <label className='form-check-label' htmlFor='past-payment'>
              Gecikmiş Ödemeleri Göster
            </label>
          </div>
          <div className='form-check form-check-custom form-check-solid me-5 p-2 rounded-start rounded-end'>
            <input className='form-check-input' type='checkbox' id='today-calls'onChange={(e) => setTodayRecall(e.target.checked)} style={{border: "3px solid #ffed00"}}/>
            <label className='form-check-label' htmlFor='today-calls'>
              Bugün Tekrar Aranacakları Göster
            </label>
          </div>
          <div className='form-check form-check-custom form-check-solid me-5 p-2 rounded-start rounded-end'>
            <input className='form-check-input' type='checkbox' id='future-payment' onChange={(e) => setPassedExpiry(e.target.checked)} style={{border: "3px solid #ffed00"}}/>
            <label className='form-check-label' htmlFor='future-payment'>
              Vadesi Olanları Gizle
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CustomerFilter
